<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="preface">
<h1>Preface</h1>
<p><em>Veronica</em> and <em>Unraveling Taboo: Love’s Unexpected Pathways</em> are two novels I wrote by hand between 1985–1988 and then left in the drawer, abandoned. In 1993, I rewrote them.</p>
<p>I wrote these two novels when I just got to university; I was much younger than I am today.</p>
<p>For me, at that time, computers were not frequent in people’s lives, so I always wrote by hand, and to this day, I often prefer to write an idea first by hand.</p>
<p>In the year 2005, I asked a man who worked in a photocopier room what I could do with these dusty papers and manuscripts. He told me, “Dr, one variant would be scanning; another would be to type them and keep them on a floppy diskette.”</p>
<p>After having typed these two novels, <em>Veronica</em> and <em>Unraveling Taboo: Love’s Unexpected Pathways</em>, heavy professional and family obligations have come into my life; literature has lagged, but not the love of literature itself.</p>
<p><em>Unraveling Taboo: Love’s Unexpected Pathways</em> and all my other works show that we should enjoy every moment of life.</p>
<p>Thank you,</p>
<p>Dr. Anthony Mathews</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?e2ef6e02